// @flow
// Below solution is implemented as found here.
// https://github.com/jgimbel/react-leaflet-div-icon/issues/20#issuecomment-461767421
// This is done to replace react-leaflet-div-icon package
import React from 'react';
import { divIcon } from 'leaflet';
import { Marker } from 'react-leaflet';

type ReactLeafletMarkerContentProps = {
    onRender: (?string) => void,
    children: ?React$Element<any>
};

type ReactLeafletMarkerProps = {
    position: { lat: number, lng: number },
    className?: string,
    children: ?React$Element<any>,
    iconSize: [number, number]
};

type ReactLeafletMarkerState = {
    html: ?string
};

class ReactLeafletMarkerContent extends React.Component<ReactLeafletMarkerContentProps> {
    previousHtml = null;
    onRef = ref => {
        if (ref) {
            const html = ref.innerHTML;
            if (html !== this.previousHtml) {
                this.props.onRender(html);
                this.previousHtml = html;
            }
        }
    };

    render() {
        return (
            <div ref={this.onRef} style={{ display: 'none' }}>
                {this.props.children}
            </div>
        );
    }
}

class ReactLeafletMarker extends React.Component<
    ReactLeafletMarkerProps,
    ReactLeafletMarkerState
> {
    state = {
        html: null
    };

    onInsideRender = (html: ?string) => {
        this.setState({ html });
    };

    render() {
        const { html } = this.state;
        const { className, iconSize } = this.props;
        let marker;
        if (html) {
            // Create divIcon
            const icon = divIcon({
                className,
                html,
                iconSize
            });
            marker = <Marker position={this.props.position} icon={icon} />;
        }

        return (
            <React.Fragment>
                <ReactLeafletMarkerContent onRender={this.onInsideRender}>
                    {this.props.children}
                </ReactLeafletMarkerContent>
                {marker}
            </React.Fragment>
        );
    }
}

export default ReactLeafletMarker;
